import React from 'react';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import { parseAmount, friendlyDate } from 'app/utils/parsers';
import history from 'app/routes/history';

import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import { CardBody, Card } from 'reactstrap';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import SuccessIcon from 'app/images/icons/success.svg';

interface IReceiptPrintComponentProps {
  ref: any;
  matchCardData: {
    round: string;
    dateTime: string;
    eventInfo: string;
    amount: string;
    section: string;
    time: string;
    location: string;
    status: string;
    otherTeamStatus: string;
    statuses: [
      {
        colour: string;
        text: string;
      }
    ];
  };
  status: string;
  receiptType: string;
  reference: string;
  contextReference: string;
  paidAt: string;
  paymentAmount: string;
  paymentType: string;
  paymentMethod: string;
  section: string;
  description: string;
  paymentReference: string;
  from: string;
  totalAmountPaid: number;
  lineItems: { amount: number; description: string }[];
}

export default class ReceiptPrintComponent extends React.Component<
  IReceiptPrintComponentProps,
  {}
> {
  static defaultProps: IReceiptPrintComponentProps = {
    ref: undefined,
    matchCardData: {
      round: undefined,
      dateTime: undefined,
      eventInfo: undefined,
      amount: undefined,
      section: undefined,
      time: undefined,
      location: undefined,
      statuses: undefined,
      status: undefined,
      otherTeamStatus: undefined,
    },
    status: undefined,
    teamName: undefined,
    paidAt: undefined,
    section: undefined,
    description: undefined,
    paymentAmount: undefined,
    paymentMethod: undefined,
    paymentReference: undefined,
    from: undefined,
    totalAmountPaid: undefined,
    lineItems: [],
  };

  handleDownload = () => {};

  handleCollect = (e) => {
    e.preventDefault();
    history.push('/payment-requests/new');
  };

  renderLineItems = () => _.map(this.props.lineItems, (lineItem) => (
    <div className="row" key={lineItem.description}>
      <div className="col col-8 text-dark-grey">
        {lineItem.description}
      </div>
      <div className="col col-4 text-right text-dark-grey">
        {parseAmount(lineItem.amount)}
      </div>
    </div>
  ));

  renderForfeitInfo = () => (
    <div className="row with-margin-top">
      <div className="col">
        <SectionGroup>
          <div className="row">
            <div className="col">
              <span className="form-content">
                <p>
                  The forfeit has been confirmed. The opposition team will be
                  notified of the cancellation via SMS and email. Your receipt
                  is below.
                </p>
                <p className="with-no-margin-bottom">
                  If you would like your team members to pay you back, you can
                  use Teammo to collect the money.
                </p>
              </span>
            </div>
          </div>
        </SectionGroup>
      </div>
    </div>
  );

  render(): React.ReactNode {
    return (
      <div>
        <div className="row with-margin-top">
          <div className="col">
            <h1 className="text-center">
              Receipt from
              {' '}
              {this.props.from}
            </h1>
          </div>
        </div>
        {!_.isEmpty(this.props.matchCardData) && (
          <div className="row">
            <div className="col">
              <PaymentCardMin {...this.props.matchCardData} truncatedButtons />
            </div>
          </div>
        )}
        <Card>
          <CardBody className="with-extra-padding">
            <div className="row">
              <div className="col">
                <h3 className="text-black">
                  Receipt from
                  {' '}
                  {this.props.from}
                </h3>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="divider full" />
              </div>
            </div>
            <div className="row">
              <div className="col col-4 caption-text text-grey">
                Payment Status
              </div>
              <div className="col text-right capitalize normal-text">                
                {this.props.status}
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col col-4 caption-text text-grey">
                Receipt Reference
              </div>
              <div className="col text-right normal-text">
                {this.props.reference}
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col col-4 caption-text text-grey">
                Match Reference
              </div>
              <div className="col text-right normal-text">
                {this.props.contextReference}
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col col-4 caption-text text-grey">Date Paid</div>
              <div className="col text-right normal-text">
                {friendlyDate(this.props.paidAt)}
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col col-4 caption-text text-grey">
                Payment Method
              </div>
              <div className="col text-right normal-text">
                {this.props.paymentMethod}
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="divider full" />
              </div>
            </div>
            <div className="row with-margin-bottom">
              <div className="col text-black text-weight-medium">
                Summary
              </div>
            </div>
            {this.renderLineItems()}
            <div className="row">
              <div className="col">
                <div className="divider full" />
              </div>
            </div>
            <div className="row">
              <div className="col text-black text-weight-medium">
                Amount Paid
              </div>
              <div className="col text-right text-dark-grey text-weight-medium">
                {parseAmount(this.props.totalAmountPaid)}
              </div>
            </div>
            <div className="row">
              <div className="col" />
            </div>
            <div className="row">
              <div className="col">
                <div className="divider full" />
              </div>
            </div>
            <div className="row">
              <div className="col normal-text text-grey">
                If you have any questions, please visit our
                {' '}
                <a
                  href="https://help.teammo.com.au"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  help centre
                </a>
                .
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}
